import React from "react";

export const Bubble = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={92} height={50} rx={1} fill="#F1F2F6" />

    <g fill="none" stroke="#8E97A9" strokeMiterlimit={10} strokeWidth={0.5}>
      <rect x={5.5} y={5.5} width={81} height={39} />
      <line x1={5.5} y1={13.3} x2={86.5} y2={13.3} />
      <line x1={5.5} y1={21.1} x2={86.5} y2={21.1} />
      <line x1={5.5} y1={28.9} x2={86.5} y2={28.9} />
      <line x1={5.5} y1={36.7} x2={86.5} y2={36.7} />
      <line x1={66.25} y1={44.5} x2={66.25} y2={5.5} />
      <line x1={46} y1={44.5} x2={46} y2={5.5} />
      <line x1={25.75} y1={44.5} x2={25.75} y2={5.5} />
    </g>
    <circle cx={69.88} cy={21.5} r={5} fill="#FF6500" />
    <circle cx={17.38} cy={34} r={3} fill="#FFC250" />
  </g>
);
